import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import EstoqueItemDetail from './EstoqueItemDetail';
import { estoqueApi } from '../../api/estoque';
import { COLORS } from '../../theme';

export default function EstoqueList() {
  const [itens, setItens] = useState([]);
  const [busca, setBusca] = useState('');
  const [produtoAbertoId, setProdutoAbertoId] = useState(undefined);

  const carregar = useCallback(() => {
    estoqueApi.resumo(busca ? { busca } : {}).then(setItens).catch(() => {});
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);

  if (produtoAbertoId !== undefined) {
    return <EstoqueItemDetail produtoId={produtoAbertoId} onVoltar={() => { setProdutoAbertoId(undefined); carregar(); }} />;
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}` }}>
          <Input placeholder="Buscar por código, descrição ou código do fabricante..." value={busca}
            onChange={e => setBusca(e.target.value)} style={{ width: 380 }} />
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Código</th>
              <th style={{ padding: 10 }}>Descrição</th>
              <th style={{ padding: 10 }}>Código Fabricante</th>
              <th style={{ padding: 10 }}>Total em Estoque</th>
              <th style={{ padding: 10 }}>Reservado</th>
              <th style={{ padding: 10 }}>Disponível</th>
              <th style={{ padding: 10 }}>Total Esperado</th>
            </tr>
          </thead>
          <tbody>
            {itens.map(item => (
              <tr key={item.id} onClick={() => setProdutoAbertoId(item.id)}
                style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                <td style={{ padding: 10 }}>{item.codigo}</td>
                <td style={{ padding: 10 }}>{item.nome}</td>
                <td style={{ padding: 10 }}>{item.codigo_fabricante || '-'}</td>
                <td style={{ padding: 10, fontWeight: 600 }}>{Number(item.total_estoque)}</td>
                <td style={{ padding: 10, color: Number(item.total_reservado) > 0 ? COLORS.warning : COLORS.textMid }}>
                  {Number(item.total_reservado) > 0 ? Number(item.total_reservado) : '-'}
                </td>
                <td style={{ padding: 10, fontWeight: 600 }}>{Number(item.total_disponivel)}</td>
                <td style={{ padding: 10, color: Number(item.total_esperado) > 0 ? COLORS.primary : COLORS.textMid }}>
                  {Number(item.total_esperado) > 0 ? `+${Number(item.total_esperado)}` : '-'}
                </td>
              </tr>
            ))}
            {itens.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum produto encontrado.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
